import type { ColorMode } from "@chakra-ui/react";
import { useEffect, useState } from "react";

import { getSystemTheme } from "util/theme";

export const useSystemTheme = (): ColorMode => {
  const [systemTheme, setSystemTheme] = useState<ColorMode>(getSystemTheme());

  useEffect(() => {
    if (typeof window === "undefined") return;

    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

    const handleChange = (e: MediaQueryListEvent) => {
      setSystemTheme(e.matches ? "dark" : "light");
    };

    // Add listener
    mediaQuery.addEventListener("change", handleChange);

    // Cleanup
    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);

  return systemTheme;
};
